import { Button, Table, TableData, TableRow, ToastMessage } from '@cokitchen/cokitchen-components';
import PageHeaderText from 'components/base/page-header-text';
import { ReactComponent as HORIZONTAL_DOTS } from 'assets/icons/horizontal-dots.svg';
import React, { useEffect, useState } from 'react';
import AddRoleModal from 'components/modals/add-role-modal';
import { apiService } from 'services/base.service';
import { toast } from 'react-toastify';
import { RoleType } from 'models/role.model';
import { formatDate } from 'utils/functions';
import useRoleContext from 'contexts/role.context';
import { InventoryModule, RolePermission } from 'models/permission.model';

const TABLE_HEADERS = ['Name of Role', 'Description', 'Date created', ''];

type RolesResponseType = {
  status: string;
  message: string;
  data: RoleType[];
  pagination: {
    total: number;
    page_size: number;
    current_page: number;
  };
};
const ManageRoles = () => {
  const { can } = useRoleContext();
  const [showAddRoleModal, setShowAddRoleModal] = useState(false);
  const [roles, setRoles] = useState<RolesResponseType>();
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const canManageRoles = can(InventoryModule.Role, RolePermission.Write);
  const getRoles = async () => {
    setLoading(true);
    try {
      const response = await apiService.get('user/role', { params: { page } });
      if (response) {
        setRoles(response?.data);
      }
    } catch (err: any) {
      toast(
        <ToastMessage
          message={err.response?.data?.message || 'Error fetching roles'}
          type='error'
        />
      );
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getRoles();
  }, [page]);

  const getSelectedPage = async (val: { selected: number }) => {
    const pageNo = val.selected + 1;
    setPage(pageNo);
  };
  return (
    <div>
      <PageHeaderText
        title='Manage Roles'
        // description='Manage and track the quantity of items in stocks'
      >
        {canManageRoles && (
          <Button
            variant='block'
            color='primary'
            className='px-[37px] py-[9.5px] text-sm font-medium'
            onClick={() => setShowAddRoleModal(true)}>
            Add Role
          </Button>
        )}
      </PageHeaderText>
      {loading ? (
        <div className='flex justify-center items-center'>
          <p>Loading</p>
        </div>
      ) : !roles ? (
        <div className='flex justify-center items-center'>
          <p>No roles available</p>
        </div>
      ) : (
        <Table
          headers={TABLE_HEADERS}
          onPageChange={getSelectedPage}
          pageCount={Math.ceil(roles?.pagination?.total / roles?.pagination?.page_size)}
          isAllSelected={false}
          onToggleAll={() => console.log('select all')}
          loading={false}>
          {roles.data.map((role, index) => (
            <TableRow className='text-gray-12' key={index}>
              <TableData className='text-gray-10 flex gap-3 items-center font0-medium'>
                <p> {role?.name}</p>
              </TableData>
              <TableData>
                <p> {role?.description}</p>
              </TableData>

              <TableData className='px-5 text-gray-5'>
                <p>{formatDate(role?.created_at)}</p>
              </TableData>

              <TableData className='flex items-center gap-3'>
                <>
                  <HORIZONTAL_DOTS />
                </>
              </TableData>
            </TableRow>
          ))}
        </Table>
      )}

      {showAddRoleModal && canManageRoles && (
        <AddRoleModal
          refreshData={getRoles}
          show={showAddRoleModal}
          onClose={() => setShowAddRoleModal(false)}
        />
      )}
    </div>
  );
};
export default ManageRoles;
